export const COMPANY_BUSINESS_INFO_DEFAULT_MCC_CODE = '6513';

export const COMPANY_BUSINESS_INFO_DEFAULT_SUMMARY = 'Real Estate Agents and Managers - Rentals';

export const COMPANY_BUSINESS_INFO_PATCH_DEFAULTS = {
  mccCode: COMPANY_BUSINESS_INFO_DEFAULT_MCC_CODE,
  summary: COMPANY_BUSINESS_INFO_DEFAULT_SUMMARY,
} as const;
